import { NextUI } from '@/components/NextUI';
import Button from '@/components/NextUI/Button';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { useCheckoutIntentPrefetch } from '@/features/subscription/hooks/useCheckoutIntentPrefetch';
import { Spinner } from '@heroui/spinner';
import React from 'react';
import { useAppDispatch } from '@/hooks/redux';
import { showSide } from '@/store/slices/sideSlice';
import { useTranslations } from 'next-intl';

function PremiumModal() {
  const t = useTranslations('modals.premium');
  const { monthlyPrices, yearlyPrices, isLoadingPrices } = usePaddlePricing();
  const dispatch = useAppDispatch();
  const monthlyPriceId = monthlyPrices[0]?.id;
  const yearlyPriceId = yearlyPrices[0]?.id;
  const { intentHandlers: monthlyIntentHandlers } = useCheckoutIntentPrefetch({
    getPriceParams: () =>
      monthlyPriceId ? { priceId: monthlyPriceId } : undefined,
  });
  const { intentHandlers: yearlyIntentHandlers } = useCheckoutIntentPrefetch({
    getPriceParams: () =>
      yearlyPriceId ? { priceId: yearlyPriceId } : undefined,
  });

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'PremiumModal'}
    >
      <div className="flex flex-col items-start justify-start w-full">
        <span className="text-2xl font-semibold text-dark">{t('title')}</span>

        <p className="text-gray-medium text-[17px] mt-6">{t('description1')}</p>
        <p className="text-gray-medium text-[17px] mt-6">{t('description2')}</p>

        <div className="flex justify-end gap-4 mt-8 w-full">
          <Button variant="outline" className="w-[160px]">
            {t('buttons.cancel')}
          </Button>
          {isLoadingPrices ? (
            <div className={'flex justify-center'}>
              <Spinner />
            </div>
          ) : (
            <>
              {monthlyPrices.map((price, index) =>
                index === 0 ? (
                  <Button
                    key={index}
                    className="w-[160px]"
                    {...monthlyIntentHandlers}
                    onClick={() =>
                      dispatch(
                        showSide({
                          sideKey: 'paymentScreen',
                          sideData: {
                            selectedPriceId: price.id,
                            variant: 'free',
                          },
                        })
                      )
                    }
                  >
                    {t('buttons.monthly')}
                  </Button>
                ) : (
                  ''
                )
              )}
              {yearlyPrices.map((price, index) =>
                index === 0 ? (
                  <Button
                    key={index}
                    className="w-[160px]"
                    {...yearlyIntentHandlers}
                    onClick={() =>
                      dispatch(
                        showSide({
                          sideKey: 'paymentScreen',
                          sideData: {
                            selectedPriceId: price.id,
                            variant: 'free',
                          },
                        })
                      )
                    }
                  >
                    {t('buttons.yearly')}
                  </Button>
                ) : (
                  ''
                )
              )}
            </>
          )}
        </div>
      </div>
    </NextUI.Modal>
  );
}

export default PremiumModal;
